import { RouterProvider } from "routes";

export function App() {
  return <RouterProvider />;
}

export default App;
